import { NgOptimizedImage } from '@angular/common';
import { Component, computed, Input, EventEmitter, Output, Signal, input } from '@angular/core';
import { UploadFile } from 'ngx-uploader';
import { BytesConverterPipe } from '../../pipes/bytes-converter.pipe';

@Component({
  imports: [BytesConverterPipe, NgOptimizedImage],
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: '../../../../static/styles/components/file-preview.scss',
})
export class FileUploadComponent {
  @Output() changeFile = new EventEmitter();
  file = input.required<UploadFile | undefined>();

  @Input() documentUrl?: string;
  @Input() documentDownloadUrl?: string;

  fileTypeIcon: Signal<string> = computed<string>(() => {
    if (this.file()) {
      switch (true) {
        case this.file()?.type === 'application/pdf': {
          return './assets/icons/pdf-file-icon.svg';
        }
        case this.file()?.type === 'text/csv': {
          return './assets/icons/csv-file-icon.svg';
        }
        case this.file()?.type.includes('image'): {
          return './assets/icons/img-file-icon.svg';
        }
      }
    }
    return './assets/icons/csv-file-icon.svg';
  });

  onChangeFile() {
    this.changeFile.emit(true);
  }
}
